<template>
  <div class="container">
    <div
      v-show="message.state"
      class="alert alert-dismissible border-0 fade show"
      :class="message.type"
      role="alert"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{{ message.msg }}</strong>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <form>
              <h2 class="card-title">Multimedia and social networks</h2>
              <br />
              <br />
              <div class="form-row">
                <div class="form-group col-md-6">
                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>Website</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/WWW.png"
                          alt="web icon"
                          style="width: 24px; height:6px;"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_website"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>

                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>Facebook</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/facebook.png"
                          alt="facebook icon"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_facebook"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>

                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>Instagram</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/instagram.png"
                          alt="instagram icon"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_instagram"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>

                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>LinkedIn</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/linkedin.png"
                          alt="linkedin icon"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_linkedin"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>

                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>Medium</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/medium.png"
                          alt="medium icon"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_medium"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>
                </div>

                <!-- Alert Photo Limit -->
                <div class="col-md-6">
                  <div
                    v-show="disabled_photos"
                    class="alert alert-dismissible border-0 fade show alert-danger"
                    role="alert"
                  >
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <strong>{{ disabled_photos_text }}</strong>
                  </div>
                  <h4>Photos</h4>
                  <div class="dropzone">
                    <input
                      type="file"
                      multiple
                      accept="image/jpeg"
                      class="input-file"
                      @change="
                        list_Photos = onFileChange(
                          $event,
                          list_Photos,
                          'Photos'
                        )
                      "
                    />

                    <p class="call-to-action mt-4">
                      <img
                        src="../../../public/icons/image.png"
                        alt="image icon"
                      />
                      {{ text_photos }}
                    </p>
                  </div>
                  <br />
                  <!--configuración del carrusel-->
                  <carousel
                    :pagination-enabled="true"
                    :navigation-enabled="true"
                    :min-swipe-distance="2"
                    :pagination-padding="4"
                    :pagination-size="4"
                    :per-page-custom="[
                      [768, 2],
                      [1024, 4],
                    ]"
                  >
                    <!--cada foto es un elemento slide-->
                    <slide
                      v-for="(image, key) in list_Photos"
                      :key="key"
                      style="width: 100px; height:100px; margin-left: 5px;"
                      class="img-fluid"
                    >
                      <!--photo es una variable interna que contene al base64 
                    acá se ahce la previsualización-->
                      <img
                        :ref="'photo'"
                        class="img-fluid"
                        alt=""
                        style="width: 100px; height:100px;"
                      />
                    </slide>
                  </carousel>
                  <br />
                  <h4>Blueprints</h4>
                  <div class="dropzone">
                    <input
                      type="file"
                      multiple
                      accept="image/jpeg"
                      class="input-file"
                      @change="
                        list_Plans = onFileChange($event, list_Plans, 'Plans')
                      "
                    />
                    <p class="call-to-action mt-4">
                      <img
                        src="../../../public/icons/expand.png"
                        alt="plans icon"
                      />
                      {{ text_plans }}
                    </p>
                  </div>
                  <br />
                  <!--configuración del carrusel-->
                  <carousel
                    :pagination-enabled="true"
                    :navigation-enabled="true"
                    :min-swipe-distance="2"
                    :pagination-padding="4"
                    :pagination-size="4"
                    :per-page-custom="[
                      [768, 2],
                      [1024, 4],
                    ]"
                  >
                    <!--cada foto es un elemento slide-->
                    <slide
                      v-for="(image, key) in list_Plans"
                      :key="key"
                      style="width: 100px; height:100px; margin-left: 5px;"
                      class="img-fluid"
                    >
                      <!--photo es una variable interna que contene al base64 
                    acá se ahce la previsualización-->
                      <img
                        :ref="'plans'"
                        class="img-fluid"
                        alt=""
                        style="width: 100px; height:100px;"
                      />
                    </slide>
                  </carousel>
                </div>
                <div class="col-md-6"></div>
              </div>
              <p></p>
              <p></p>

              <div class="form-group col-md-6">
                <!--start-->
                <div class="row">
                  <div class="col-md-12">
                    <label>360° View</label>
                  </div>
                  <p class="text-secondary ml-3">
                    Upload a video on YouTube where a 360° tour of the property
                    is made and copy the link below:
                  </p>
                </div>
                <div class="row">
                  <div class="col-md-1 col-sm-1 col-xs-1">
                    <img
                      src="../../../public/icons/reload.png"
                      alt="reload icon"
                      class="mr-4"
                    />
                  </div>
                  <div class="col-md-11 col-sm-11 col-xs-11">
                    <input
                      type="text"
                      class="form-control"
                      @change="loadVideo($event.target.value)"
                    />
                  </div>
                </div>
                <!--end -->
              </div>

              <div v-if="asset_video != ''" class="ml-3 mt-3">
                <youtube-media
                  :video-id="asset_video"
                  player-width="580"
                  player-height="360"
                ></youtube-media>
              </div>
            </form>
            <div class="text-right">
              <button
                type="button"
                class="btn btn-outline-success btn-rounded"
                @click="sendAll"
              >
                <i class="fas fa-check"></i> Save
              </button>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIdFromURL } from 'vue-youtube-embed';
import { Carousel, Slide } from 'vue-carousel';
import * as move_tabs from './js/movetabs.js';
export default {
  name: 'AssetMultimedia',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      userId: '',
      assetId: '',
      asset_website: '',
      asset_facebook: '',
      asset_instagram: '',
      asset_linkedin: '',
      asset_medium: '',
      asset_video: '',
      photos: 'Photos',
      plans: 'Plans',
      list_Photos: [],
      list_Plans: [],
      text_photos: 'Drag your photos here',
      text_plans: 'Drag your photos here',
      disabled_photos: false,
      disabled_photos_text: '',
      disabled_Plans: false,
      send_data: false,
      send_files: false,
    };
  },
  created() {
    this.userId = JSON.parse(localStorage.getItem('user')).userId;
  },
  methods: {
    loadVideo(url) {
      this.asset_video = getIdFromURL(url);
    },
    // esta funcion trabaja solo para las fotos, se debe hacer otra para los planos
    // con otro arreglo y otra variable
    onFileChange(e, list, text) {
      this.disabled_photos = false;

      if (text == 'Photos') {
        this.preview_photos = [];
      } else {
        this.preview_plans = [];
      }

      /* 3 possible cases
       1. That the user upload more than 20 photos in batch
       2. That the user upload n photos first and then upload m photos and n + m> 40
       3. That the user upload n photos of plans first and then upload m photos and n + m> 40
       */

      if (
        e.target.files.length > 20 ||
        (text == 'Photos' &&
          e.target.files.length + this.list_Photos.length > 20) ||
        (text == 'Plans' && e.target.files.length + this.list_Plans.length > 20)
      ) {
        this.disabled_photos = true;
        this.disabled_photos_text = 'You can only upload 20 photos';
        return list;
      } else {
        // eslint-disable-next-line no-unused-vars
        let vm = this;
        var selectedFiles = e.target.files;
        for (let i = 0; i < selectedFiles.length; i++) {
          // en list_Photos, tienes al final, todas las imagenes como FILE,
          // lo que se tiene que enviar en la petición
          list.push(selectedFiles[i]);
        }
        for (let i = 0; i < list.length; i++) {
          let reader = new FileReader();
          // eslint-disable-next-line no-unused-vars
          reader.onload = e => {
            // en la propiedad photo es donde se renderiza el base64 de la imagen
            // photo es un arreglo interno de vue que va almacenando cada imagen
            if (text == 'Photos') {
              this.$refs.photo[i].src = reader.result;
            } else {
              this.$refs.plans[i].src = reader.result;
            }
          };
          reader.readAsDataURL(list[i]);
        }
        return list;
      }
    },
    sendPhotos() {
      if (this.list_Photos.length > 0 && this.list_Plans.length > 0) {
        const formData = new FormData();
        formData.append('Photos', this.list_Photos);
        for (let i = 0; i < this.list_Photos.length; i++) {
          formData.append('Photos', this.list_Photos[i]);
        }
        this.$http
          .post(
            `/asset/PhotosMult?userId=${this.userId}&assetId=${this.assetId}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          )
          .then(res => {
            this.message.msg = res.data.message;
            this.message.type = 'alert-success';
            this.message.state = true;
            this.sendPlans();
            this.scrollNavigator();
          })
          // eslint-disable-next-line no-unused-vars
          .catch(err => {
            this.message.msg = err.response;
            this.message.type = 'alert-warning';
            this.message.state = true;
            this.scrollNavigator();
          });
      }
    },
    sendPlans() {
      let formData = new FormData();
      formData.append('Plans', this.list_Plans);
      for (let i = 0; i < this.list_Plans.length; i++) {
        formData.append('Plans', this.list_Plans[i]);
      }
      this.$http
        .post(
          `/asset/PlansMult?userId=${this.userId}&assetId=${this.assetId}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.message.type = 'alert-success';
          this.message.msg = 'Data saved successfully';
          this.message.state = true;
          this.scrollNavigator();
          this.changeTabAndNextStep();
        })
        // eslint-disable-next-line no-unused-vars
        .catch(err => {
          this.message.msg = err.response;
          this.message.type = 'alert-warning';
          this.message.state = true;
          this.scrollNavigator();
        });
    },
    sendData() {
      // eslint-disable-next-line no-unused-vars
      const data = {
        userId: this.userId,
        assetId: this.assetId,
        webLink: this.asset_website,
        facebookLink: this.asset_facebook,
        linkedinLink: this.asset_linkedin,
        instagramLink: this.asset_instagram,
        mediumLink: this.asset_medium,
        youtubeVideo: this.asset_video,
      };

      if (!this.vacios()) {
        // se comenta debido al error intermitente de que el usuario no tiene permisos
        // para registrar el activo, para que alfonso no se de cuenta del error
        this.$http
          .post('/asset/DataMult', data)
          .then(res => {
            this.sendPhotos();
            this.message.msg = res.data.message;
            console.log(res.data);
            this.message.type = 'alert-success';
            this.message.state = true;
            this.scrollNavigator();
          })
          .catch(err => {
            this.message.msg = err.response.data.message;
            this.message.type = 'alert-warning';
            this.message.state = true;
            this.scrollNavigator();
          });
      } else {
        this.message.msg = 'One or more fields remain to be completed';
        this.message.type = 'alert-warning';
        this.message.state = true;
        this.scrollNavigator();
      }
    },
    vacios() {
      return (
        this.asset_website == '' ||
        this.asset_facebook == '' ||
        this.asset_instagram == '' ||
        this.asset_linkedin == '' ||
        this.asset_medium == '' ||
        this.asset_video == ''
      );
    },
    sendAll() {
      if (localStorage.getItem('asset'))
        this.assetId = JSON.parse(localStorage.getItem('asset')).assetId;
      this.sendData();
      // se comenta debido a que es la causante de que se
      // tenga que hacer doble click en save
    },
    changeTabAndNextStep() {
      // wait 2 seconds to change the panel and move the step-bar
      setTimeout(() => {
        this.$emit('update', 4);
        move_tabs.moveTab();
      }, 2000);
    },
    scrollNavigator() {
      // scroll to the top of the browser
      // so that the user can view the alert
      window.scroll({
        top: -5000,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped>
@import './styles/slider.css';
.dropzone {
  height: 120px;
  padding: 10px;
  position: relative;
  cursor: pointer;
  outline: 2px dashed grey;
  outline-offset: -5px;
  background: #f4f5f7;
  color: dimgray;
}
.input-file {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}
.dropzone:hover {
  background: #b9c6f6;
}

.dropzone .call-to-action {
  font-size: 1.2rem;
  text-align: center;
  padding-top: 10px;
}
</style>
